import styled from "styled-components";
import { theme } from '../../theme'


export const SupportTopWrapper = styled.div`
    background-color: ${theme.colors.mainBlue};
`
export const ButtonContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 1.1rem;

    @media only screen and (max-width: 478px) {
        flex-direction: column;
        /* margin-top:20px; */
     }
`
export const MainContent = styled.div`
    padding: 0px 10px;

    .page-title{
        font-weight: 700;
        font-size: 1.2rem;
        line-height: 1.6rem;
        letter-spacing: 1px;
        color: #FFFFFF;
        text-transform: uppercase;
    }

    .top {
        .school-name {
            font-weight: 700;
            font-size: 5.1rem;
            color: ${theme.colors.mainWhite};

            @media only screen and (max-width: 500px) {
                text-align: center;
             }

            @media only screen and (max-width: 326px) {
                font-size: 4.1rem;
            }
        }
    }

    .bottom {
        font-size: 1.2rem;
        color: #FFFFFF;
        display: flex;
        justify-content: space-between;

        @media only screen and (max-width: 500px) {
            flex-direction: column;
            font-size: 1.5rem;

            & > div {
                margin: 0 auto 2rem auto;
                text-align: center;
            }
         }

        
    }

    .button-container {
        margin-top: 2.5rem;
        
        @media only screen and (max-width: 500px) {
            display: flex;
            justify-content: center;
        }
    }
    
`

export const StyleSingleChatBox = styled.div`
background-color: #FFFFFF;
box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.0293252);
border-radius: 11px;
    margin-bottom: 3.9rem;
    display: flex;
    flex-direction: column;
    align-items:  ${({ type }) => type === 'received' ? 'flex-start' : 'flex-end'} ;
    .chat-time {
        font-size: 1rem;
        color: #979797;
    }
    
`;
export const StyledReceivedMessageBox = styled.div`
    display: flex;
    gap: 1rem;
    padding: 2rem 1.1rem;
    font-size: 1.2rem;  
    text-align:  ${({ type }) => type === 'received' ? 'initial' : 'end'} ;  

    .name {
        font-weight: 700;
        font-size: 1.4rem;
        color: #3B3B42;
    }
    .ticket-reply {
        margin-top: 1.6rem;
        margin-bottom: 5px;
        font-size: 1.2rem;
        color: #979797
    }
`;